import { render } from "./AdminReservationView.vue?vue&type=template&id=8873ba86&scoped=true"
import script from "./AdminReservationView.vue?vue&type=script&lang=js"
export * from "./AdminReservationView.vue?vue&type=script&lang=js"

import "./AdminReservationView.css?vue&type=style&index=0&id=8873ba86&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8873ba86"]])

export default __exports__